import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy URL scheme. The site previously served product pages under `/product/`;
// the current route is `/produk/`. Permanently redirect so old indexed links and
// external backlinks land on the correct page (deleted products then 404 there).
export const Route = createFileRoute('/product/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/produk/$id', params: { id: params.id }, statusCode: 301 })
  },
})
